import { PlatformDisplayItem, PlatformItem, PointOfSale, PushNotificationHistory, TargetPushNotification } from '@m4a3/api-client';

import { PlatformProduct } from '@m4a3/api-client/dist/models/platform-product.interface';
import { orderfulApi, deliveryApi } from '../services/api-instances';

export const getProducts = (cellId: number): Promise<PlatformItem[]>=> {
  return orderfulApi.getAllProductsForCell(cellId);
};

export const addProduct = (product: PlatformProduct): Promise<PlatformProduct> => {
  return orderfulApi.addProduct(product);
};

export const updateProduct = (product: PlatformProduct): Promise<PlatformProduct> => {
  return orderfulApi.updateProduct(product);
};

export const getPointOfSales = (): Promise<PointOfSale[]> => {
  return orderfulApi.getAllPointOfSales();
};

export const getSpecialOffers = (cellId: number): Promise<PlatformDisplayItem[]> => {
  const onlyShowCurrentlyDisplayedOffers = false;
  return orderfulApi.getSpecialOffersForCell(cellId, onlyShowCurrentlyDisplayedOffers);
};

export const addSpecialOffer = (specialOffer: PlatformDisplayItem): Promise<PlatformDisplayItem> => {
  return orderfulApi.addSpecialOffer(specialOffer);
};

export const deleteSpecialOffer = (id: string): Promise<null> => {
  return orderfulApi.deletePlatformItem(id);
};

export const updateSpecialOffer = (specialOffer: PlatformDisplayItem): Promise<PlatformDisplayItem> => {
  return orderfulApi.updateSpecialOffer(specialOffer);
};

export const getAppDisplayProducts = (cellId: number): Promise<PlatformDisplayItem[]> => {
  return orderfulApi.getDisplayProductsForCell(cellId);
};

export const addAppDisplayProduct = (cellId: number, displayProduct: Omit<PlatformDisplayItem, 'id'>): Promise<PlatformDisplayItem> => {
  return orderfulApi.addDisplayProductToCell(cellId, displayProduct);
};

export const deleteAppDisplayProduct = (id: string): Promise<null> => {
  return orderfulApi.deletePlatformItem(id);
};

export const getActiveNotifications = (cellId: number): Promise<PushNotificationHistory[]> => {
  return orderfulApi.getActiveNotificationsForCell(cellId, {displayToday: true})
};

export const getTargetNotificationOptions = (): Promise<TargetPushNotification[]>=> {
  return orderfulApi.getTargetNotificationOptions()
}

export const getReachCountForNotificationType = (cellId: number, notificationType: string): Promise<number> => {
  return orderfulApi.getReachCountForNotificationType(cellId, notificationType)
}
